

import { useDispatch, useSelector } from "react-redux";
import CheckoutFinishedView from "./view"
import { useEffect, useState } from "react";
import { clearUser } from "@/redux/ducks/user";
import { openApp } from "@/utils/functions";
import { useNavigate } from "react-router-dom";
import { ReducersTypes } from "@/redux/reducers/Models";
import useTicket from "@/hooks/useTicket";

export default function CheckoutFinished() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const user = useSelector((state: ReducersTypes) => state.userReducer);

  const [error, setError] = useState<boolean>(false);

  const { 
    isLoading, 
    getTickets, 
    getInvoice, 
    generatePDF,
    invoice,
    toggleModal,
    isVisibleModal,
  } = useTicket();

  const toggleError = () => setError(prev => !prev);

  const goToPlayStore = () => {
    openApp("android");
  }

  const goToAppleStore = () => {
    openApp("ios");
  }

  const goToTickets = () => navigate('/ticket/pin');

  const goBack = () => navigate('/');

  const openInvoice = () => {
    getTickets(() => {
      const currentTickets = user?.tickets;

      if (!currentTickets || currentTickets.length === 0) {
        toggleError();
        return;
      }

      const [latest] = currentTickets;

      getInvoice({
        id: latest.id,
        date: latest.date,
        price: latest.price,
        status: latest.status,
      });
    });
  }

  useEffect(() => {   
    return () => {
      dispatch(clearUser());
    };
  }, []);

  return (
    <CheckoutFinishedView
      goToPlayStore={goToPlayStore}
      goToAppleStore={goToAppleStore}
      goBack={goBack}
      goToTickets={goToTickets}
      invoice={invoice}
      toggleModal={toggleModal}
      toggleModalRegister={() => {navigate('/register')}}
      generatePDF={generatePDF}
      isVisibleModal={isVisibleModal}
      isLoading={isLoading}
      openInvoice={openInvoice}
      error={error}
      toggleError={toggleError}
      handleTryAgain={() => {
        toggleError();
        openInvoice();
      }}
    />
  );
}
